/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

// Utils
import { useCookies } from 'react-cookie';
import jwt_decode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../store/AppContext';

const withAuth = (Component) => {
  function Auth(props) {
    const navigate = useNavigate();

    const [mounted, setMounted] = useState(false);

    const [{ user }, stateDispatch] = useAppContext();
    const [cookies] = useCookies(['jwt']);

    useEffect(() => { setMounted(true); }, []);

    useEffect(() => {
      if (mounted) {
        if (cookies?.jwt) {
          const decodedUser = jwt_decode(cookies?.jwt);
          if (decodedUser) {
            stateDispatch({ type: 'SET_USER', payload: decodedUser });
          }
        } else {
          navigate('/logout');
        }
      }
    }, [mounted]);

    if (user) return <Component {...props} />;
    return null;
  }

  if (Component.getInitialProps) {
    Auth.getInitialProps = Component.getInitialProps;
  }

  return Auth;
};

export default withAuth;
